import { render } from "./VersionInformation.vue?vue&type=template&id=500ea229&scoped=true"
import script from "./VersionInformation.vue?vue&type=script&lang=js"
export * from "./VersionInformation.vue?vue&type=script&lang=js"

import "./VersionInformation.vue?vue&type=style&index=0&id=500ea229&lang=less&scoped=true"

import exportComponent from "D:\\yisa_project\\访客预约系统\\vrs_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500ea229"]])

export default __exports__